import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { EncuestasService } from '../encuestas.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.css']
})
export class PreguntasComponent implements OnInit {
preguntas:any=[]
mostrarPregunta:boolean=false

  constructor(private toastr:ToastrService, private srv:EncuestasService, public router: Router,) {



    // this.preguntas=[
    //   {
    //     pregunta:'Le gustan las alitas?',
    //     respuestas:[{respuesta:'SI'},{respuesta:'NO'}]
    //   },
      // {
      //   pregunta:'Le gustan La pizza?',
      //   respuestas:[{respuesta:'SI'},{respuesta:'NO'},{respuesta:'MAS O MENOS'}]
      // }
    // ]
   }
   nombreEncuesta:any=''
   idPersonaEncuesta:any=''
   getEncuestaActiva(){
    this.srv.getEncuestasActivas('',data=>{
      if (data.data && data.data.table0) {
        this.nombreEncuesta=data.data.table0[0]?.descripcionEncuesta;
         this.srv.iniciarEncuesta({idEncuesta:data.data.table0[0].idEncuesta},data=>{

        // var datos= [
        //         {
        //             "idEncuesta": 3,
        //             "descripcionEncuesta": "Enceusta de pruebas #3",
        //             "observacionEncuesta": "Es une aprueba",
        //             "tituloEncuesta": "",
        //             "subTituloEncuesta": "",
        //             "textEncabezado": "",
        //             "fechaInicioVigencia": "2024-09-01",
        //             "fechaFinVigencia": "2024-10-01",
        //             "horaInicioVigencia": "00:30:11",
        //             "horaFinVigencia": "23:59:59",
        //             "idPersonaEncuesta": 7,
        //             "idPersona": 1,
        //             "fechaEncuesta": "2024-09-03T11:42:04.9091796",
        //             "finalizada": false,
        //             "fechaFinalizada": null,
        //             "fechaRegistro": "2024-09-03T11:42:04.9091796",
        //             "preguntas": [
        //                 {
        //                     "idPregunta": 22,
        //                     "pregunta": "¿Elija una opcion para verificar?",
        //                     "preguntaActiva": true,
        //                     "opcionesRespuesta": [
        //                         {
        //                             "idPreguntaOpcionRespuesta": 28,
        //                             "idOpcionRespuesta": 1,
        //                             "idPregunta": 22,
        //                             "opcionRespuesta": "SI",
        //                             "idPersonaEncuestaDetalle": null,
        //                             "seleccinado": false
        //                         },
        //                         {
        //                             "idPreguntaOpcionRespuesta": 29,
        //                             "idOpcionRespuesta": 2,
        //                             "idPregunta": 22,
        //                             "opcionRespuesta": "NO",
        //                             "idPersonaEncuestaDetalle": null,
        //                             "seleccinado": false
        //                         }
        //                     ]
        //                 }
        //             ]
        //         }
        //     ]

           this.preguntas=data.data.table0;
          // this.preguntas=datos;
         })
        
      }else{
        this.toastr.warning('No hay encuestas activas.')
      }
})
   }
   refresh(){
    this.getEncuestaActiva();
   }

   onRadioChange(event: any,item) {
    var selectedValue = event.value;
    console.log(item, selectedValue);

    var obj={
      idPersonaEncuesta:item.idPersonaEncuesta,
      idPregunta:selectedValue.idPregunta,
      idOpcionRespuesta: selectedValue.idOpcionRespuesta
    }
    console.log(obj)
    this.srv.saveRespuesta(obj,data=>{
      console.log(data);

      this.mostrarPregunta=true;
      this.getEncuestaActiva();
  
          const source = interval(1000);
      
      this.subscription = source.subscribe(val => {
        if (this.segundos > 0) {
          this.segundos--;
        } else {
           this.mostrarPregunta=false;
          this.subscription.unsubscribe(); // Detiene el contador cuando llega a 0
          // localStorage.clear();
          // this.router.navigateByUrl('/validar-usuario');
        
        }
      });
    })

  }
  segundos: number = 5; // Tiempo inicial en segundos
  private subscription: Subscription;
  ngOnInit(): void {
    this.getEncuestaActiva();
  }
  salir(){
    localStorage.clear();
     this.router.navigateByUrl('/validar-usuario');
  }

}
